import { Container, Stack, Typography } from '@mui/material';
import iconStyles from 'src/components/css/iconStyle';
import MetbusLogo from 'src/components/MetbusLogo';
import VersionDisplayer from 'src/components/shared/VersionDisplayer';
import { THEMES } from 'src/constants';
import useSettings from 'src/hooks/useSettings';
import LogoDT from 'src/icons/LogoDT';
import CardLogin from 'src/pages/authentication/components/login/CardLogin';
import LoginContainer from 'src/pages/authentication/components/LoginContainer';

const LoginMailInspector = () => {
  const { settings } = useSettings();
  let contrastColor = false;
  if (settings.theme === THEMES.METBUSLIGHT) {
    contrastColor = true;
  }
  return (
    <LoginContainer>
      <Container
        maxWidth="xs"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          gap: '2rem',
          height: '100%',
        }}
      >
        <CardLogin
          onlyDtDomain={true}
          titleComponent={
            <>
              <Stack
                direction={'column'}
                alignItems={'center'}
                gap={'1rem'}
              >
                <MetbusLogo
                  height="72"
                  width="240"
                  contrastColor={contrastColor}
                />
                <Typography
                  color="textSecondary"
                  variant="body2"
                  mb={2}
                >
                  Acceso Dirección del Trabajo
                </Typography>
              </Stack>
              <LogoDT
                sx={{
                  ...iconStyles,
                  minHeight: '170px',
                  minWidth: '170px',
                  pr: '2rem',
                }}
              />
            </>
          }
        />
        <VersionDisplayer horizontal />
      </Container>
    </LoginContainer>
  );
};

export default LoginMailInspector;
